import { compose } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../../actions/SettingProductCompany';
import withAuth from '../../../common/WithAuth';
import SettingProductCompany from '../../../pages/Admin/SettingProductCompany/SettingProductCompany';

const mapStateToProps = (state) => ({
    infoSettingProduct: state.settingProductCompany.get.data,
    isLoading: state.settingProductCompany.get.isFetching || state.settingProductCompany.update.isFetching,
    errorGetSetting: state.settingProductCompany.get.errors,
    updateSuccess: state.settingProductCompany.update.updateSuccess,
    errorUpdate: state.settingProductCompany.update.errors,
});

const mapDispatchToProps = (dispatch) => ({
    getSettingProductCompany: (params) => {
        dispatch(Actions.GetSettingProductCompanyRequested(params));
    },
    clearSettingProduct: () => {
        dispatch(Actions.ClearSettingProductCompany());
    },
    updateSettingProductCompany: (params) => {
        dispatch(Actions.UpdateSettingProductCompanyRequested(params));
    },
    clearUpdate: () => {
        dispatch(Actions.ClearUpdate());
    },
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(SettingProductCompany);
